// src/pages/GameDetails/index.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./style.css";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:4000";

const GameDetails = () => {
  const { id } = useParams();
  const [gameData, setGameData] = useState(null);
  const [similar, setSimilar] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await axios.get(`${API_BASE}/api/games/${id}`);
        setGameData(res.data.game);
        setSimilar(res.data.similar || []);
      } catch (err) {
        console.error("Failed to load game", err);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, [id]);

  if (loading) {
    return (
      <div className="games-loading-container">
        <div className="games-loading-spinner"></div>
        <p>Loading game...</p>
      </div>
    );
  }

  if (!gameData) {
    return <div style={{ padding: 24 }}><h1>Please note that this page is still in construction and may have incomplete features.</h1> Game not found.</div>;
  }

  const cover = gameData.cover?.url ? "https:" + gameData.cover.url.replace("t_thumb", "t_cover_big") : null;
  const screenshots = (gameData.screenshots || []).map(s => "https:" + s.url.replace("t_thumb", "t_screenshot_huge"));

  return (
    <div className="games-page-container" style={{ paddingBottom: 60 }}>
      <h1>Please note that this page is still in construction and may have incomplete features.</h1>
      <div className="games-page-content">
        <button onClick={() => navigate(-1)} style={{ marginBottom: 12 }} className="games-toggle-btn">← Back</button>

        <div className="games-grid-card" style={{ display: "flex", gap: 24 }}>
          <div style={{ minWidth: 320 }}>
            {cover ? <img src={cover} style={{ width: "100%", borderRadius: 8 }} alt={gameData.name} /> : null}
            {screenshots.length > 0 && (
              <div style={{ marginTop: 12, display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 8 }}>
                {screenshots.slice(0,4).map((s, i) => (
                  <img key={i} src={s} alt={`screenshot-${i}`} style={{ width: "100%", borderRadius: 6 }} />
                ))}
              </div>
            )}
          </div>

          <div style={{ flex: 1 }}>
            <h1 style={{ marginTop: 0 }}>{gameData.name}</h1>
            <p style={{ color: "#666" }}>{gameData.first_release_date ? new Date(gameData.first_release_date * 1000).toLocaleDateString() : ""}</p>
            <p style={{ fontWeight: 600, color: "#2e7d32" }}>Rating: {Math.round(gameData.rating || 0)} / 100</p>
            <div style={{ margin: "16px 0" }}>
              <strong>Genres:</strong>{" "}
              {(gameData.genres || []).map(g => g.name).join(", ")}
            </div>
            <div style={{ marginBottom: 10 }}>
              <strong>Platforms:</strong>{" "}
              {(gameData.platforms || []).map(p => p.name).join(", ")}
            </div>

            <div style={{ marginTop: 12 }}>
              <h3>Summary</h3>
              <p style={{ lineHeight: 1.6 }}>{gameData.summary || "No summary available."}</p>
            </div>

            {gameData.storyline && (
              <div>
                <h3>Storyline</h3>
                <p>{gameData.storyline}</p>
              </div>
            )}
          </div>
        </div>

        {similar.length > 0 && (
          <div style={{ marginTop: 24 }}>
            <h3>Similar Games</h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 12 }}>
              {similar.map(s => {
                const img = s.cover?.url ? "https:" + s.cover.url.replace("t_thumb", "t_cover_big") : "https://via.placeholder.com/300x200?text=No+Image";
                const date = s.first_release_date ? new Date(s.first_release_date * 1000).toLocaleDateString() : "";
                return (
                  <div key={s.id} onClick={() => navigate(`/games/${s.id}`)} style={{ cursor: "pointer", background: "#fff", padding: 8, borderRadius: 8 }}>
                    <img src={img} alt={s.name} style={{ width: "100%", borderRadius: 6 }} />
                    <div style={{ marginTop: 8 }}>
                      <div style={{ fontWeight: 700 }}>{s.name}</div>
                      <div style={{ color: "#474747ff", fontSize: 13 }}>{date}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}

export default GameDetails;